import { toast } from 'react-toastify'
import style from './tabs.module.scss'

export function formatDueDate(dateStr) {
    if (dateStr.length !== 8) return dateStr
    const year = dateStr.substring(0, 4)
    const month = dateStr.substring(4, 6)
    const day = dateStr.substring(6, 8)
    return `${year}/${month}/${day}`
}

export const getBadgeClass = {
    unpub: style['badge-red'],
    pub: style['badge-yellow'],
    sng: style['badge-yellow'],
    fnl: style['badge-green'],
    del: style['badge-red'],
}

export const getNoteClass = {
    pub: 'bg-yellow-1 border shadow-md rounded-lg p-2 text-black',
    sng: 'bg-yellow-1 border shadow-md rounded-lg p-2 text-black',
    fnl: 'bg-green-1 border shadow-md rounded-lg p-2 text-black',
    del: 'bg-gray-5 border shadow-md rounded-lg p-2 text-black',
}

export const getBadgeText = {
    unpub: 'صادر نشده',
    pub: 'صدور پیش نویس',
    sng: 'در مرحله امضا',
    fnl: 'صادر شده',
    del: 'حذف شده',
}

export const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
        () => {
            toast.info('شماره خزانه داری در کلیپبورد کپی شد')
        },
        (err) => {
            toast.error('خطا در کپی کردن متن:', err)
        }
    )
}
